// layouts
import Layout from '../layouts';
//auth
import { useRouter } from 'next/router';
// components
import LoadingScreen from '../components/LoadingScreen';
import useAuth from '../hooks/useAuth';
import { useEffect } from 'react';

/* ----------------------------------------------------------------------------
   Entrada por token na URL: /<token>.

   ⚠ ACHADO QUE MUDA O QUE ESTA TELA E: `setToken` NAO EXISTE no contexto de
   autenticacao. O JWTContext expoe `login`, `logout`, `accessTokenState` e
   `register` - e nada mais (src/contexts/JWTContext.tsx:280). Ou seja
   `useAuth().setToken` e `undefined`, e era por isso que a chamada estava
   protegida por `if (setToken)`. O token que vem na URL e simplesmente
   DESCARTADO: esta rota nunca autenticou ninguem.

   Fazer a entrada por token funcionar de verdade exige acrescentar `setToken` ao
   contexto, o que e mexer em autenticacao - fora do que foi autorizado. Ficou
   registrado no PENDENCIAS. A chamada protegida continua aqui: no dia em que
   alguem adicionar `setToken`, ela passa a valer sozinha.

   O QUE FOI CORRIGIDO e o efeito colateral disso: com o token descartado e os
   dois defeitos abaixo, quem abria um link `/<token>` ficava na LoadingScreen
   PARA SEMPRE - sem mensagem e sem caminho de volta. Agora vai para o login (ou
   para o dashboard, se ja tiver sessao), que e o comportamento honesto.

   DOIS DEFEITOS DE NAVEGACAO CORRIGIDOS:

   1. `pathname == '/'` NUNCA e verdadeiro aqui. A rota deste arquivo e `/:token`,
      e o shim de next/router devolve `location.pathname` real (src/compat/
      next-router.tsx:43), isto e `/abc123`. Como o teste era

         if (isInitialized && !isAuthenticated && pathname == '/') push(login)
         else if (isInitialized && isAuthenticated) push(dashboard)

      o primeiro ramo nunca entrava; e por ser `else if`, quando o usuario NAO
      estava autenticado o segundo tambem nao entrava. Resultado: quem chegava com
      um token invalido ou expirado ficava na LoadingScreen para sempre, sem
      mensagem e sem caminho de volta.

   2. O `push()` estava no CORPO do componente. No react-router, navegar durante o
      render e ignorado (o proprio React avisa: "You should call navigate() in a
      React.useEffect()"). Mesmo defeito que ja tinha sido corrigido em
      pages/index.jsx - com o comentario explicando - e que aqui havia sobrado.

   Tambem removidos: RootStyle/ContentStyle (styled do MUI) que existiam no
   arquivo e nunca apareciam no JSX.
   ---------------------------------------------------------------------------- */

TokenPage.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function TokenPage() {
  const { isAuthenticated, setToken, isInitialized } = useAuth();
  const { push, query } = useRouter();

  const { token } = query;

  useEffect(() => {
    if (token && setToken) setToken(token);
  }, [token]);

  // Espera a inicializacao do contexto de auth antes de decidir: sem isso, o
  // primeiro render (ainda sem sessao restaurada) mandaria todo mundo para o
  // login, inclusive quem acabou de entregar um token valido.
  useEffect(() => {
    if (!isInitialized) return;
    if (isAuthenticated) push('/dashboard/app/');
    else push('/auth/login');
  }, [isInitialized, isAuthenticated, push]);

  return <LoadingScreen />;
}
